const LITER_VARIANTS = new Set(["l", "lt", "litro", "litros", "liter", "liters", "litre", "litres"]);

// Matches any liter variant optionally followed by a separator and a denominator
// e.g. "l/trabajador", "litros / empleado", "l / unit"
const LITER_COMPOUND_RE = /^(l|lt|litros?|liters?|litres?)\s*\/\s*(.+)$/i;

/**
 * Normalizes a unit string for display to the user.
 * Ensures the liter abbreviation is always shown as "L" (uppercase).
 */
export function normalizeUnit(unit) {
  if (!unit) return unit;
  const trimmed = unit.trim();
  if (LITER_VARIANTS.has(trimmed.toLowerCase())) return "L";
  const match = trimmed.match(LITER_COMPOUND_RE);
  if (match) return "L/" + match[2];
  return trimmed;
}
